import Request from './request';

import {
  ApiResult,
  CreateModelRequest,
  CreateModelResponse,
  DeployedModelsPayload,
  DeployedModelsResult,
  Model,
  TrainAndDeployRequest,
  UpdateModelRequest,
} from '@controlrooms/models';

export const ML_OPS = '/ml-deployment-manager/api';

export const getAllTargetModels = (target_type: string, target: string): Promise<Model[]> =>
  Request.get(`${ML_OPS}/models?target_type=${target_type}&target=${target}`)
    .then(({ result }) => result)
    .catch((err) => {
      console.error('Error fetching models', err);
    });

export const getModelByEnsembleId = (ensemble_id: number): Promise<Model> =>
  Request.get(`${ML_OPS}/models/${ensemble_id}`)
    .then(({ result }) => result)
    .catch((err) => {
      console.error('Error fetching model', err);
    });

export const createModel = (
  requestBody: CreateModelRequest,
): Promise<ApiResult<CreateModelResponse>> => {
  return Request.post(`${ML_OPS}/model`, requestBody);
};

export const updateModel = (
  ensemble_id: number,
  requestBody: UpdateModelRequest,
): Promise<ApiResult<CreateModelResponse>> => {
  return Request.put(`${ML_OPS}/model/${ensemble_id}`, requestBody);
};

export const trainModel = (
  requestBody: TrainAndDeployRequest,
  ensemble_id: number,
): Promise<{
  model_id: number;
  ensemble_id?: number;
  status: string;
  model_version: number;
}> =>
  Request.post(`${ML_OPS}/models/${ensemble_id}/train`, requestBody)
    .then(({ result }) => result)
    .catch((err) => {
      console.error('Error training model', err);
      throw err;
    });

export const deployModel = (
  ensemble_id: number,
  ensemble_family?: string | null,
): Promise<{
  model_id: number;
  status: string;
  model_version: number;
}> => {
  const body: Record<string, unknown> = {};
  if (ensemble_family) {
    body.ensemble_family = ensemble_family;
  }
  return Request.post(`${ML_OPS}/models/${ensemble_id}/deploy`, body)
    .then(({ result }) => result)
    .catch((err) => {
      console.error('Error deploying model', err);
      throw err;
    });
};

export const deployedModels = (payload: DeployedModelsPayload): Promise<DeployedModelsResult> =>
  Request.post(`${ML_OPS}/deployed_models`, payload, { timeout: 15000 }).then(
    (r) => new DeployedModelsResult(r),
  );
